import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { ImageEditorComponent } from '../image-editor/image-editor.component';


@Component({
  selector: 'app-t-image-compression',
  templateUrl: './t-image-compression.component.html',
  styleUrls: ['./t-image-compression.component.css']
})
export class TImageCompressionComponent extends GeneralTeacherComponent {

  @ViewChild('imageEditor',{static: true}) imageEditor: ImageEditorComponent;
  colors: string = "bw";
  highlight: boolean = true;
  image: string[][];

  constructor(topicService: TopicService, activatedRoute: ActivatedRoute) {
    super(topicService, activatedRoute)
    this.title = this.get("imageCompression");
    this.type = "imageCompression";
  }

  ngAfterViewInit() {
    if (this.image) {
      this.imageEditor.setImage(this.image);
    }
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.colors = this.configuration.typespecifics.colors;
    this.highlight = this.configuration.typespecifics.highlight;
    this.image = this.configuration.typespecifics.image;
    this.imageEditor.setImage(this.image);
  }

  generateDefinition() {
    let definition: any = {};
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/imageCompression.png";
    definition.level = this.colors=="bw"?2:3;
    definition.key = "compression%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};
    definition.typespecifics.image = this.imageEditor.getImage();
    this.image = this.imageEditor.getImage();
    definition.typespecifics.colors = this.colors;
    definition.typespecifics.highlight = this.highlight;
    definition.key = definition.key.concat("%", this.image.toString());

    console.log("[".concat(this.image.map(v => v.map(v => "'".concat(v, "'"))).map(v => "[".concat(v.join(","), "]")).join(","), "]"));

    return definition;
  }

  generate() {
    this.colors = "bw";
    this.imageEditor.colors = "bw";
    this.image = this.imageEditor.possibleImages[Math.floor(Math.random()*this.imageEditor.possibleImages.length)];
    this.imageEditor.setImage(this.image);
    this.highlight = true;
  }

  reset(){
    super.reset();
    this.title  =this.get("imageCompression");
    this.colors = "bw";
    this.highlight = true;
    this.imageEditor.initImage(true);
  }


}
